// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1_types.ml",
      203,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "OperationType"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "PaymentType"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "DomainType"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "ItemType"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "TaxType"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "ReportType"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "MoneyPlacementType"
                    ]
                  ]
                },
                "V1"
              ]]
          },
          "Kassa"
        ]]
    });

const Kassa = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1_types.ml",
      371,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "OperationType"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "PaymentType"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "DomainType"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "ItemType"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "TaxType"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "ReportType"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "MoneyPlacementType"
              ]
            ]
          },
          "V1"
        ]]
    });

const V1 = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1_types.ml",
      537,
      10
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "OperationType"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "PaymentType"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "DomainType"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "ItemType"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "TaxType"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "ReportType"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "MoneyPlacementType"
        ]
      ]
    });

const OperationType = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1_types.ml",
      560,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

const PaymentType = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1_types.ml",
      627,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

const DomainType = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1_types.ml",
      702,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

const ItemType = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1_types.ml",
      783,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

const TaxType = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1_types.ml",
      853,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

const ReportType = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1_types.ml",
      895,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

const MoneyPlacementType = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1_types.ml",
      942,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.kassa.v1.OperationType";
}

function to_int(param) {
  return param;
}

function from_int_exn(n) {
  if (n > 4 || n < 0) {
    return Ocaml_protoc_plugin__Result.raise({
                NAME: "Unknown_enum_value",
                VAL: n
              });
  } else {
    return n;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn(e);
            });
}

function to_string(param) {
  switch (param) {
    case /* OPERATION_TYPE_UNSPECIFIED */0 :
        return "OPERATION_TYPE_UNSPECIFIED";
    case /* OPERATION_TYPE_SALE */1 :
        return "OPERATION_TYPE_SALE";
    case /* OPERATION_TYPE_SALE_RETURN */2 :
        return "OPERATION_TYPE_SALE_RETURN";
    case /* OPERATION_TYPE_PURCHASE */3 :
        return "OPERATION_TYPE_PURCHASE";
    case /* OPERATION_TYPE_PURCHASE_RETURN */4 :
        return "OPERATION_TYPE_PURCHASE_RETURN";
    
  }
}

function from_string_exn(s) {
  switch (s) {
    case "OPERATION_TYPE_PURCHASE" :
        return /* OPERATION_TYPE_PURCHASE */3;
    case "OPERATION_TYPE_PURCHASE_RETURN" :
        return /* OPERATION_TYPE_PURCHASE_RETURN */4;
    case "OPERATION_TYPE_SALE" :
        return /* OPERATION_TYPE_SALE */1;
    case "OPERATION_TYPE_SALE_RETURN" :
        return /* OPERATION_TYPE_SALE_RETURN */2;
    case "OPERATION_TYPE_UNSPECIFIED" :
        return /* OPERATION_TYPE_UNSPECIFIED */0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, OperationType, {
      name: name,
      to_int: to_int,
      from_int: from_int,
      from_int_exn: from_int_exn,
      to_string: to_string,
      from_string_exn: from_string_exn
    });

function name$1(param) {
  return ".buhta.kassa.v1.PaymentType";
}

function to_int$1(param) {
  return param;
}

function from_int_exn$1(n) {
  if (n > 5 || n < 0) {
    return Ocaml_protoc_plugin__Result.raise({
                NAME: "Unknown_enum_value",
                VAL: n
              });
  } else {
    return n;
  }
}

function from_int$1(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn$1(e);
            });
}

function to_string$1(param) {
  switch (param) {
    case /* PAYMENT_TYPE_UNSPECIFIED */0 :
        return "PAYMENT_TYPE_UNSPECIFIED";
    case /* PAYMENT_TYPE_CASH */1 :
        return "PAYMENT_TYPE_CASH";
    case /* PAYMENT_TYPE_CARD */2 :
        return "PAYMENT_TYPE_CARD";
    case /* PAYMENT_TYPE_CREDIT */3 :
        return "PAYMENT_TYPE_CREDIT";
    case /* PAYMENT_TYPE_TARE */4 :
        return "PAYMENT_TYPE_TARE";
    case /* PAYMENT_TYPE_MOBILE */5 :
        return "PAYMENT_TYPE_MOBILE";
    
  }
}

function from_string_exn$1(s) {
  switch (s) {
    case "PAYMENT_TYPE_CARD" :
        return /* PAYMENT_TYPE_CARD */2;
    case "PAYMENT_TYPE_CASH" :
        return /* PAYMENT_TYPE_CASH */1;
    case "PAYMENT_TYPE_CREDIT" :
        return /* PAYMENT_TYPE_CREDIT */3;
    case "PAYMENT_TYPE_MOBILE" :
        return /* PAYMENT_TYPE_MOBILE */5;
    case "PAYMENT_TYPE_TARE" :
        return /* PAYMENT_TYPE_TARE */4;
    case "PAYMENT_TYPE_UNSPECIFIED" :
        return /* PAYMENT_TYPE_UNSPECIFIED */0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, PaymentType, {
      name: name$1,
      to_int: to_int$1,
      from_int: from_int$1,
      from_int_exn: from_int_exn$1,
      to_string: to_string$1,
      from_string_exn: from_string_exn$1
    });

function name$2(param) {
  return ".buhta.kassa.v1.DomainType";
}

function to_int$2(param) {
  return param;
}

function from_int_exn$2(n) {
  if (n > 6 || n < 0) {
    return Ocaml_protoc_plugin__Result.raise({
                NAME: "Unknown_enum_value",
                VAL: n
              });
  } else {
    return n;
  }
}

function from_int$2(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn$2(e);
            });
}

function to_string$2(param) {
  switch (param) {
    case /* DOMAIN_TYPE_UNSPECIFIED */0 :
        return "DOMAIN_TYPE_UNSPECIFIED";
    case /* DOMAIN_TYPE_TRADING */1 :
        return "DOMAIN_TYPE_TRADING";
    case /* DOMAIN_TYPE_SERVICES */2 :
        return "DOMAIN_TYPE_SERVICES";
    case /* DOMAIN_TYPE_GASOIL */3 :
        return "DOMAIN_TYPE_GASOIL";
    case /* DOMAIN_TYPE_HOTELS */4 :
        return "DOMAIN_TYPE_HOTELS";
    case /* DOMAIN_TYPE_TAXI */5 :
        return "DOMAIN_TYPE_TAXI";
    case /* DOMAIN_TYPE_PARKING */6 :
        return "DOMAIN_TYPE_PARKING";
    
  }
}

function from_string_exn$2(s) {
  switch (s) {
    case "DOMAIN_TYPE_GASOIL" :
        return /* DOMAIN_TYPE_GASOIL */3;
    case "DOMAIN_TYPE_HOTELS" :
        return /* DOMAIN_TYPE_HOTELS */4;
    case "DOMAIN_TYPE_PARKING" :
        return /* DOMAIN_TYPE_PARKING */6;
    case "DOMAIN_TYPE_SERVICES" :
        return /* DOMAIN_TYPE_SERVICES */2;
    case "DOMAIN_TYPE_TAXI" :
        return /* DOMAIN_TYPE_TAXI */5;
    case "DOMAIN_TYPE_TRADING" :
        return /* DOMAIN_TYPE_TRADING */1;
    case "DOMAIN_TYPE_UNSPECIFIED" :
        return /* DOMAIN_TYPE_UNSPECIFIED */0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, DomainType, {
      name: name$2,
      to_int: to_int$2,
      from_int: from_int$2,
      from_int_exn: from_int_exn$2,
      to_string: to_string$2,
      from_string_exn: from_string_exn$2
    });

function name$3(param) {
  return ".buhta.kassa.v1.ItemType";
}

function to_int$3(param) {
  switch (param) {
    case /* ITEM_TYPE_UNSPECIFIED */0 :
        return 0;
    case /* ITEM_TYPE_COMMODITY */1 :
        return 1;
    case /* ITEM_TYPE_MARKUP */2 :
        return 2;
    case /* ITEM_TYPE_DISCOUNT */3 :
        return 3;
    case /* ITEM_TYPE_STORNO_COMMODITY */4 :
        return 11;
    case /* ITEM_TYPE_STORNO_MARKUP */5 :
        return 12;
    case /* ITEM_TYPE_STORNO_DISCOUNT */6 :
        return 13;
    
  }
}

function from_int_exn$3(n) {
  switch (n) {
    case 0 :
        return /* ITEM_TYPE_UNSPECIFIED */0;
    case 1 :
        return /* ITEM_TYPE_COMMODITY */1;
    case 2 :
        return /* ITEM_TYPE_MARKUP */2;
    case 3 :
        return /* ITEM_TYPE_DISCOUNT */3;
    case 4 :
    case 5 :
    case 6 :
    case 7 :
    case 8 :
    case 9 :
    case 10 :
        return Ocaml_protoc_plugin__Result.raise({
                    NAME: "Unknown_enum_value",
                    VAL: n
                  });
    case 11 :
        return /* ITEM_TYPE_STORNO_COMMODITY */4;
    case 12 :
        return /* ITEM_TYPE_STORNO_MARKUP */5;
    case 13 :
        return /* ITEM_TYPE_STORNO_DISCOUNT */6;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_value",
                  VAL: n
                });
  }
}

function from_int$3(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn$3(e);
            });
}

function to_string$3(param) {
  switch (param) {
    case /* ITEM_TYPE_UNSPECIFIED */0 :
        return "ITEM_TYPE_UNSPECIFIED";
    case /* ITEM_TYPE_COMMODITY */1 :
        return "ITEM_TYPE_COMMODITY";
    case /* ITEM_TYPE_MARKUP */2 :
        return "ITEM_TYPE_MARKUP";
    case /* ITEM_TYPE_DISCOUNT */3 :
        return "ITEM_TYPE_DISCOUNT";
    case /* ITEM_TYPE_STORNO_COMMODITY */4 :
        return "ITEM_TYPE_STORNO_COMMODITY";
    case /* ITEM_TYPE_STORNO_MARKUP */5 :
        return "ITEM_TYPE_STORNO_MARKUP";
    case /* ITEM_TYPE_STORNO_DISCOUNT */6 :
        return "ITEM_TYPE_STORNO_DISCOUNT";
    
  }
}

function from_string_exn$3(s) {
  switch (s) {
    case "ITEM_TYPE_COMMODITY" :
        return /* ITEM_TYPE_COMMODITY */1;
    case "ITEM_TYPE_DISCOUNT" :
        return /* ITEM_TYPE_DISCOUNT */3;
    case "ITEM_TYPE_MARKUP" :
        return /* ITEM_TYPE_MARKUP */2;
    case "ITEM_TYPE_STORNO_COMMODITY" :
        return /* ITEM_TYPE_STORNO_COMMODITY */4;
    case "ITEM_TYPE_STORNO_DISCOUNT" :
        return /* ITEM_TYPE_STORNO_DISCOUNT */6;
    case "ITEM_TYPE_STORNO_MARKUP" :
        return /* ITEM_TYPE_STORNO_MARKUP */5;
    case "ITEM_TYPE_UNSPECIFIED" :
        return /* ITEM_TYPE_UNSPECIFIED */0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, ItemType, {
      name: name$3,
      to_int: to_int$3,
      from_int: from_int$3,
      from_int_exn: from_int_exn$3,
      to_string: to_string$3,
      from_string_exn: from_string_exn$3
    });

function name$4(param) {
  return ".buhta.kassa.v1.TaxType";
}

function to_int$4(param) {
  if (param) {
    return 1;
  } else {
    return 0;
  }
}

function from_int_exn$4(n) {
  if (n !== 0) {
    if (n !== 1) {
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_value",
                  VAL: n
                });
    } else {
      return /* TAX_TYPE_VAT */1;
    }
  } else {
    return /* TAX_TYPE_UNSPECIFIED */0;
  }
}

function from_int$4(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn$4(e);
            });
}

function to_string$4(param) {
  if (param) {
    return "TAX_TYPE_VAT";
  } else {
    return "TAX_TYPE_UNSPECIFIED";
  }
}

function from_string_exn$4(s) {
  switch (s) {
    case "TAX_TYPE_UNSPECIFIED" :
        return /* TAX_TYPE_UNSPECIFIED */0;
    case "TAX_TYPE_VAT" :
        return /* TAX_TYPE_VAT */1;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, TaxType, {
      name: name$4,
      to_int: to_int$4,
      from_int: from_int$4,
      from_int_exn: from_int_exn$4,
      to_string: to_string$4,
      from_string_exn: from_string_exn$4
    });

function name$5(param) {
  return ".buhta.kassa.v1.ReportType";
}

function to_int$5(param) {
  return param;
}

function from_int_exn$5(n) {
  if (n > 2 || n < 0) {
    return Ocaml_protoc_plugin__Result.raise({
                NAME: "Unknown_enum_value",
                VAL: n
              });
  } else {
    return n;
  }
}

function from_int$5(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn$5(e);
            });
}

function to_string$5(param) {
  switch (param) {
    case /* REPORT_TYPE_UNSPECIFIED */0 :
        return "REPORT_TYPE_UNSPECIFIED";
    case /* REPORT_TYPE_X */1 :
        return "REPORT_TYPE_X";
    case /* REPORT_TYPE_Z */2 :
        return "REPORT_TYPE_Z";
    
  }
}

function from_string_exn$5(s) {
  switch (s) {
    case "REPORT_TYPE_UNSPECIFIED" :
        return /* REPORT_TYPE_UNSPECIFIED */0;
    case "REPORT_TYPE_X" :
        return /* REPORT_TYPE_X */1;
    case "REPORT_TYPE_Z" :
        return /* REPORT_TYPE_Z */2;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, ReportType, {
      name: name$5,
      to_int: to_int$5,
      from_int: from_int$5,
      from_int_exn: from_int_exn$5,
      to_string: to_string$5,
      from_string_exn: from_string_exn$5
    });

function name$6(param) {
  return ".buhta.kassa.v1.MoneyPlacementType";
}

function to_int$6(param) {
  return param;
}

function from_int_exn$6(n) {
  if (n > 2 || n < 0) {
    return Ocaml_protoc_plugin__Result.raise({
                NAME: "Unknown_enum_value",
                VAL: n
              });
  } else {
    return n;
  }
}

function from_int$6(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return from_int_exn$6(e);
            });
}

function to_string$6(param) {
  switch (param) {
    case /* MONEY_PLACEMENT_TYPE_UNSPECIFIED */0 :
        return "MONEY_PLACEMENT_TYPE_UNSPECIFIED";
    case /* MONEY_PLACEMENT_TYPE_DEPOSIT */1 :
        return "MONEY_PLACEMENT_TYPE_DEPOSIT";
    case /* MONEY_PLACEMENT_TYPE_WITHDRAWAL */2 :
        return "MONEY_PLACEMENT_TYPE_WITHDRAWAL";
    
  }
}

function from_string_exn$6(s) {
  switch (s) {
    case "MONEY_PLACEMENT_TYPE_DEPOSIT" :
        return /* MONEY_PLACEMENT_TYPE_DEPOSIT */1;
    case "MONEY_PLACEMENT_TYPE_UNSPECIFIED" :
        return /* MONEY_PLACEMENT_TYPE_UNSPECIFIED */0;
    case "MONEY_PLACEMENT_TYPE_WITHDRAWAL" :
        return /* MONEY_PLACEMENT_TYPE_WITHDRAWAL */2;
    default:
      return Ocaml_protoc_plugin__Result.raise({
                  NAME: "Unknown_enum_name",
                  VAL: s
                });
  }
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "to_int"
        ],
        [
          /* Function */0,
          "from_int"
        ],
        [
          /* Function */0,
          "from_int_exn"
        ],
        [
          /* Function */0,
          "to_string"
        ],
        [
          /* Function */0,
          "from_string_exn"
        ]
      ]
    }, MoneyPlacementType, {
      name: name$6,
      to_int: to_int$6,
      from_int: from_int$6,
      from_int_exn: from_int_exn$6,
      to_string: to_string$6,
      from_string_exn: from_string_exn$6
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "OperationType"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "PaymentType"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "DomainType"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "ItemType"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "TaxType"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "ReportType"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "to_int"
              ],
              [
                /* Function */0,
                "from_int"
              ],
              [
                /* Function */0,
                "from_int_exn"
              ],
              [
                /* Function */0,
                "to_string"
              ],
              [
                /* Function */0,
                "from_string_exn"
              ]
            ]
          },
          "MoneyPlacementType"
        ]
      ]
    }, V1, {
      OperationType: OperationType,
      PaymentType: PaymentType,
      DomainType: DomainType,
      ItemType: ItemType,
      TaxType: TaxType,
      ReportType: ReportType,
      MoneyPlacementType: MoneyPlacementType
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "OperationType"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "PaymentType"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "DomainType"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "ItemType"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "TaxType"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "ReportType"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "to_int"
                    ],
                    [
                      /* Function */0,
                      "from_int"
                    ],
                    [
                      /* Function */0,
                      "from_int_exn"
                    ],
                    [
                      /* Function */0,
                      "to_string"
                    ],
                    [
                      /* Function */0,
                      "from_string_exn"
                    ]
                  ]
                },
                "MoneyPlacementType"
              ]
            ]
          },
          "V1"
        ]]
    }, Kassa, {
      V1: V1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "OperationType"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "PaymentType"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "DomainType"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "ItemType"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "TaxType"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "ReportType"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "to_int"
                          ],
                          [
                            /* Function */0,
                            "from_int"
                          ],
                          [
                            /* Function */0,
                            "from_int_exn"
                          ],
                          [
                            /* Function */0,
                            "to_string"
                          ],
                          [
                            /* Function */0,
                            "from_string_exn"
                          ]
                        ]
                      },
                      "MoneyPlacementType"
                    ]
                  ]
                },
                "V1"
              ]]
          },
          "Kassa"
        ]]
    }, Buhta, {
      Kassa: Kassa
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
